

































import { Component,  Vue, Prop } from 'vue-property-decorator';
import { area, stations } from '@/api/api';
import { Notify } from 'vant';

@Component({
    name: 'suggestion'
})

export default class Suggestion extends Vue {
    private phone: string = '';
    private message: string = '';
    private showPicker: boolean = false;
    private areas: any[] = [];

    private mounted() {
        area().then((res: any) => {
            const data: any[] = res.data;
            this.areas = data;
        });
    }

    // methods
    private showSel(): void {
        this.showPicker = true;
    }
    // 选择地区
    private confirm(): void {
        //
    }
}
